import React from 'react'
import PropTypes from 'prop-types'
import { Dialog, DialogContent } from '@mui/material'
import { BasicDialogTitle } from 'common/components/modal/DialogComponents'
import { NewTable } from 'common/components/datatable/Table'
import { getFullDate } from 'common/utils/DateUtil'
import { orderBy } from 'lodash'

const PROFILE_LABEL = {
    ADMIN: 'Administrateur',
    MANAGER: 'Gestionnaire',
    USER: 'Utilisateur',
}

const ActiveUsersDialog = ({
    open = false,
    instanceName = '',
    users = [],
    onClose = () => {},
}) => {
    const rows = orderBy(users, ['lastActivity'], ['desc']).map(user => ({
        login: user.aquasys ? `${user.login} (Aquasys)` : user.login,
        profile: PROFILE_LABEL[user.profile] ?? user.profile,
        sourceType: user.sourceType,
        tokenExpiration: getFullDate(user.tokenExpiration),
        lastActivity: getFullDate(user.lastActivity),
    }))

    return (
        <Dialog open={open} maxWidth='md' fullWidth>
            <BasicDialogTitle onClose={onClose}>
                {`Utilisateurs actifs — ${instanceName}`}
            </BasicDialogTitle>
            <DialogContent>
                <NewTable
                    rows={rows}
                    headers={[
                        { key: 'login', value: 'Login' },
                        { key: 'profile', value: 'Profil' },
                        { key: 'sourceType', value: 'Module' },
                        { key: 'tokenExpiration', value: 'Expiration du token' },
                        { key: 'lastActivity', value: 'Dernière activité' },
                    ]}
                />
            </DialogContent>
        </Dialog>
    )
}

ActiveUsersDialog.propTypes = {
    open: PropTypes.bool,
    instanceName: PropTypes.string,
    users: PropTypes.arrayOf(PropTypes.shape({
        login: PropTypes.string,
        profile: PropTypes.string,
        aquasys: PropTypes.bool,
        sourceType: PropTypes.string,
        tokenExpiration: PropTypes.number,
        lastActivity: PropTypes.number,
    })),
    onClose: PropTypes.func,
}

export default ActiveUsersDialog